// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_LuL","cls2":"ProfileDropdown-cls2_XZB ProfileDropdown-cls1_LuL"};